import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

declare var i18nVS: any;
declare var SendPlainFormEmailEmpleo: any;
declare var portletNameFormEmpleo: any; // Nombre del portlet en Liferay
declare var idCiudadLiferay: any; // El id de la ciudad en la que estamos
declare var responsesMap;
declare var jsonGetContentURL: any;
declare var privaciPolicyId: any;
declare function sendFormFunction(idForm,finalURL): any;

@Component({
	selector: 'app-formulario-empleo',
	templateUrl: './formulario-empleo.component.html',
	styleUrls: ['./formulario-empleo.component.css']
})

export class AppComponent implements OnInit {
	i18nL = i18nVS;
	actionForm = ''; // Action del formulario
	portletName = ''; // Nombre del portlet
	idCiudad = '';

    showSpinner = '';
    theHtmlString = '';
    
	// Validaciones
	politicaPrivacidadClass = 'invisible';
	documentoClass = 'invisible';
	nombreClass = '';
	apellidoClass = '';

	responseFormSpinner = "invisible";
	successResponseForm = "invisible";
	errorResponseForm = "invisible";
	showResponse = false;
	responseText = "";
	responseMapKey = 0;
	inputErrorClass = "inputError";

	/*----------------------------------------------- Funciones ----------------------------------------------------*/
    public getContents(PLID) {
        this.leerDatos(PLID).subscribe(res => this.comprobandoJson(res), (err) => this.errorEnElJson(), () => this.allFine());
    }
    
	public leerDatos(PLID): Observable<Response> {
        var body = this.portletName + 'contentPLID=' + PLID;
        const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/x-www-form-urlencoded'
			})
		};
        return this.http.post(jsonGetContentURL, body, httpOptions);
    }
    
    public comprobandoJson(res) {
        this.showSpinner = 'invisible';
        this.theHtmlString = res._body;
    }

    public errorEnElJson() {
        // this.onGeneralError.emit(true);
        //console.lo('Error en la carga del contenido');
    }

    public allFine() {
        //console.lo("Contenido creado");
    }
    
	public validarFormulario() {
		var validado = true;
		if ((<HTMLInputElement>document.getElementById(this.portletName + 'nom')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById(this.portletName + 'nom')).placeholder = this.i18nL.form_campoObligatorio;
            validado = false;
			this.nombreClass = 'inputError';
        }
        if ((<HTMLInputElement>document.getElementById(this.portletName + 'prenom')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById(this.portletName + 'prenom')).placeholder = this.i18nL.form_campoObligatorio;
            validado = false;
			this.apellidoClass = 'inputError';
        }
		if ((<HTMLInputElement>document.getElementById(this.portletName + 'documento')).files.length === 0) {
			(<HTMLInputElement>document.getElementById(this.portletName + 'documento')).placeholder = this.i18nL.form_campoObligatorio;
			this.documentoClass = '';
			validado = false;
		} else {
			this.documentoClass = 'invisible';
		}

		if (!(<HTMLInputElement>document.getElementById(this.portletName + 'acceptConditions')).checked) {
			(<HTMLInputElement>document.getElementById(this.portletName + 'acceptConditions')).placeholder = this.i18nL.form_campoObligatorio;
			this.politicaPrivacidadClass = '';
			validado = false;
		}
		if (validado) {
			this.showResponseForm();
			this.responseMapKey = sendFormFunction('iniciarFormEmpleo', SendPlainFormEmailEmpleo);
		}
		return false;
	}

	public clearClass(input) { // 1 CV, 2 Aceptar condiciones
		switch(input) {
			case 1: {
				if((<HTMLInputElement>document.getElementById(this.portletName + 'documento')).files.length > 0) {
					this.documentoClass = 'invisible';
				} else {
					this.documentoClass = '';
				}
				break;
			}
			case 2: {
				if((<HTMLInputElement>document.getElementById(this.portletName + 'acceptConditions')).checked) {
					this.politicaPrivacidadClass = 'invisible';
				} else {
					this.politicaPrivacidadClass = '';
				}
				break;
			}
			default: {}
		}
	}

	public aceptarPoliticaPivacidad() {
		if((<HTMLInputElement>document.getElementById(this.portletName + 'acceptConditions')).checked !== true) {
			(<HTMLInputElement>document.getElementById(this.portletName + 'acceptConditions')).checked = true;
		} else {
			(<HTMLInputElement>document.getElementById(this.portletName + 'acceptConditions')).checked = false;
		}
		this.clearClass(2);
	}

	public showResponseForm () {
		this.resetView ();
		this.showResponse = true;
		this.checkForResponseCorutine();
		this.responseFormSpinner = "";
		this.successResponseForm = "invisible";
		this.errorResponseForm = "invisible";
		this.responseText = "";
	}
	
	private checkForResponseCorutine () {​​​​​
		if (typeof responsesMap.get(this.responseMapKey) != 'undefined' && responsesMap.get(this.responseMapKey) != "" && this.showResponse) {​​​​​
			this.responseFormSpinner = "invisible";
			var actualResponse = JSON.parse(responsesMap.get(this.responseMapKey));
			if (actualResponse.success != null) {​​​​​
				this.successResponseForm = "";
				this.responseText = actualResponse.success;
			}​​​​​ else {​​​​​
				this.errorResponseForm = "";
				this.responseText = actualResponse.error;
			}​​​​​
			this.responseMapKey = -1;
		}​​​​​ else {​​​​​
			setTimeout(() => this.checkForResponseCorutine(), 250);
		}​​​​​
	}​​​​​
	
	public resetView () {
		this.responseFormSpinner = "invisible";
		this.successResponseForm = "invisible";
		this.errorResponseForm = "invisible";
		this.showResponse = false;
		this.responseText = "";
	}

	// Retorna true si es correcto y false si esta mal
    public isMandatory(input) {
        var valorActualDelInput = input.value.trim();
        if (valorActualDelInput !== '') {
			input.classList.remove(this.inputErrorClass);
            return true;
        } else {
			input.classList.add(this.inputErrorClass);
            if (typeof input.placeholder != 'undefined') {
                input.placeholder = this.i18nL.form_campoObligatorio;
            }
            return false;
        }
    }
	
	public omit_special_char(event: KeyboardEvent, spaces: boolean) {
        if (event.key.length > 1 || event.key.length <= 0) return false;
        let k = event.key.charCodeAt(0);
        if(spaces) return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
        else return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57));
    }

	/*--------------------------------------------- Eventos ------------------------------------------------------*/
	ngOnInit() {
	    this.portletName = portletNameFormEmpleo;
        this.idCiudad = idCiudadLiferay;
	}
	
	constructor(@Inject(HttpClient) private http) { }
}




// WEBPACK FOOTER //
// ./src/app/formulario-empleo.component.ts